import { Navigate, useLocation } from 'react-router-dom';
import { readPortalSession } from '../utils/portalSession';

const LoginRedirectRoute = ({ children }) => {
  const location = useLocation();
  const adminToken = localStorage.getItem('adminToken');
  const managerToken = localStorage.getItem('managerToken');
  const workerToken = localStorage.getItem('workerToken');
  const investorToken = localStorage.getItem('investorToken');

  const session = readPortalSession();
  if (location.state?.reauthenticate || ((adminToken || managerToken) && !session)) {
    return children;
  }

  if (session) {
    return (
      <Navigate
        to={session.user.role === 'admin' ? '/super_admin/dashboard' : '/manager/dashboard'}
        replace
      />
    );
  }

  if (workerToken) {
    return <Navigate to="/workers/my_portal" />;
  }

  if (investorToken) {
    return <Navigate to="/investor/plans" />;
  }

  return children;
};

export default LoginRedirectRoute;
